import React, { Component, Fragment } from 'react';
import { ErrorMessage, Field } from 'formik';
import { FieldTypes } from 'drapcode-constant';
import { iconForField } from '../../common/custom/icon-library';
import {
  fileTypes,
  projectOnBoardAllowedField,
} from '../../common/formElements/CollectionSectionType';

const KeyCodes = {
  comma: 188,
  enter: 13,
};
const delimiters = [KeyCodes.comma, KeyCodes.enter];
export default class ProjectOnBoardFieldForm extends Component {
  validateRefCollectionId = (value) => {
    let error;
    if (!value) {
      error = 'Please select any value';
    }
    return error;
  };

  handleFieldNameChange = (e, setFieldValue) => {
    setFieldValue('fieldTitle.en', e.target.value);
    setFieldValue('placeholder.en', e.target.value);
  };

  getFieldTypes = () => {
    return Object.keys(FieldTypes)
      .filter((key) => FieldTypes[key].show)
      .filter((key) => projectOnBoardAllowedField.includes(key))
      .sort()
      .map((key) => ({
        value: key,
        label: FieldTypes[key].name,
        sortOrder: FieldTypes[key].sortOrder,
      }));
  };

  getFileTypes = () => {
    return fileTypes.map((fileType, key) => {
      return { value: fileType, label: fileType };
    });
  };

  getRestControls = (values, setFieldValue, setFieldTouched) => {
    const { text, password, email, tel, url, large_text, number, date } = FieldTypes;
    const { selectedField } = this.props;

    if (selectedField === large_text.id) {
      return (
        <div className="col-md-6 col-lg-6 col-sm-12 col-xs-12 pt-3 text-center">
          <div className="form-check">
            <label className="form-check-label">
              <Field
                className="form-check-input"
                type="radio"
                name="extraFieldSetting.textareaDisplayType"
                value={'text-area'}
                id="exampleRadios1"
              />
              Use As Textarea
              <span className="circle">
                <span className="check"></span>
              </span>
            </label>
            &nbsp;&nbsp;
            <label className="form-check-label">
              <Field
                className="form-check-input"
                type="radio"
                name="extraFieldSetting.textareaDisplayType"
                value={'text-editor'}
                id="exampleRadios1"
              />
              Use As WYSIWYG Editor
              <span className="circle">
                <span className="check"></span>
              </span>
            </label>
          </div>
        </div>
      );
    } else if (selectedField === date.id) {
      return (
        <div className="col-md-6 col-lg-6 col-sm-12 col-xs-12 text-center">
          <div className="form-check">
            <label className="form-check-label">
              <Field
                className="form-check-input"
                type="radio"
                name="extraFieldSetting.dateDisplayType"
                value={'date'}
                id="exampleRadios1"
              />
              Only Date values
              <span className="circle">
                <span className="check"></span>
              </span>
            </label>
            &nbsp;&nbsp;
            <label className="form-check-label">
              <Field
                className="form-check-input"
                type="radio"
                name="extraFieldSetting.dateDisplayType"
                value={'datetime-local'}
                id="exampleRadios1"
              />
              Date along with Time
              <span className="circle">
                <span className="check"></span>
              </span>
            </label>
          </div>
        </div>
      );
    }
  };

  render() {
    const { text, large_text, number, date, color, email, tel } = FieldTypes;
    const { values, setFieldValue, setFieldTouched, selectedField } = this.props;
    return (
      <Fragment>
        <div className="card">
          <div className="card-header card-header-text" data-background-color="drapcode-violet">
            <h6 className="card-title pb-0 mb-0 text-capitalise">Step #1: Choose Field Type</h6>
          </div>

          <div className="card-content pr-3 pl-3">
            <div className="col-12 mx-auto mb-3 mt-3">
              {this.getFieldTypes()
                .sort((a, b) => a.sortOrder - b.sortOrder)
                .map((field) => (
                  <div
                    className={`btn btn-md mr-2 text-center ${
                      field.value === selectedField ? 'btn-theme-submit' : 'btn-outline-primary'
                    }`}
                    onClick={() => this.props.changeFieldType(field.value)}
                    style={{ cursor: 'pointer', minWidth: '10.5rem' }}
                    title={`Add ${field.label} Field Type`}
                    key={field.value}
                  >
                    <strong>
                      <i className={`wb ${iconForField(field.value)}`}></i>
                      &nbsp; {field.label}
                    </strong>
                  </div>
                ))}
            </div>
          </div>
        </div>

        <div className="card">
          <div className="card-header card-header-text" data-background-color="drapcode-violet">
            <h6 className="card-title pb-0 mb-0 text-capitalise">Step #2: Enter Field Details</h6>
          </div>

          <div className="card-content pr-3 pl-3">
            <div className="row mx-auto mb-3 mt-3">
              <div className="col-md-6 col-lg-6 col-sm-12 col-xs-12">
                <div className="form-group bmd-form-group">
                  <div className="input-group">
                    <div className="input-group-prepend">
                      <span className="input-group-text">
                        <i className={`wb ${iconForField('text')}`}></i>
                        <span className="required"> *</span>
                      </span>
                    </div>
                    <Field
                      type="text"
                      name="fieldTitle.en"
                      className="form-control"
                      data-lang="en"
                      placeholder="Name Your Field"
                      onChange={(e) => this.handleFieldNameChange(e, setFieldValue)}
                    />
                    <p className="errors">
                      <ErrorMessage name="fieldTitle.en" />
                    </p>
                  </div>
                </div>
              </div>
              {this.getRestControls(values, setFieldValue, setFieldTouched)}
              {[text.id, large_text.id, number.id, date.id, color.id, email.id, tel.id].includes(
                selectedField,
              ) && (
                <div className="col-md-6 col-lg-6 col-sm-12 col-xs-12 pl-5 pt-3">
                  <div className="form-check">
                    <label className="form-check-label">
                      <Field type="checkbox" name="unique" className="form-check-input" />
                      Unique
                      <span className="form-check-sign">
                        <span className="check"></span>
                      </span>
                    </label>
                    <small>( Prevents submission of duplicate values, eg: email, SSN etc. )</small>
                    <p className="errors">
                      <ErrorMessage name="unique" />
                    </p>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}
